export default __webpack_public_path__ + "static/curb-452d0c03a44ef3ccbbc1f57e08b05d65.jpg";